import { combineReducers } from 'redux'
import config from './configReducer'

export default combineReducers({
    config
})